import { DefaultTag } from "@/shared/Components";
import type { FC, ReactNode } from "react";
import styles from "./styles.module.scss";

type Props = {
  value?: ReactNode;
  onRemove?: () => void;
  loading?: boolean;
};

export const Tag: FC<Props> = ({ onRemove, value, loading }) => {
  const shouldEllipsis = typeof value === "string" && value.length > 30;

  return (
    <div className={styles.root}>
      <DefaultTag onClose={onRemove} closable={!loading} className={styles.tag}>
        <div className={shouldEllipsis ? styles["tag-overflow"] : ""}>{value}</div>
      </DefaultTag>
    </div>
  );
};
